import { Swiper, Navigation} from "swiper/bundle";
export default class EventSwiper {
    constructor() {
        console.log('%c👍🏼 Event Swiper', 'color: yellow');     
        this.swiperEvent = document.querySelector('.swiper--event')
    }
    init() {
        const nextButton = this.swiperEvent.parentElement.querySelector('.swiper-button-next')
        const prevButton = this.swiperEvent.parentElement.querySelector('.swiper-button-prev')
        new Swiper(this.swiperEvent, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            loop: false,
            spaceBetween: 30,
            speed: 1001,
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            }
        });   
    }
}